"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

var _urijs = _interopRequireDefault(require("urijs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var noTags = {
  allowedTags: [],
  allowedAttributes: []
};

var onlyUnique = function onlyUnique(e, i, arr) {
  return arr.indexOf(e) === i;
};

var _ontologyIdsForColumnIndex = function _ontologyIdsForColumnIndex(heatmapData, x) {
  return [heatmapData.xAxisCategories[x].id];
};

var _ontologyIdsForRowIndex = function _ontologyIdsForRowIndex(heatmapData, y) {
  return [].concat.apply([], [].concat.apply([], heatmapData.dataSeries.map(function (series) {
    return series.data;
  })).filter(function (point) {
    return point.y === y && !!point.value;
  }).map(function (point) {
    return _ontologyIdsForColumnIndex(heatmapData, point.x);
  }).map(function (e) {
    return Array.isArray(e) ? e : [e];
  })).filter(onlyUnique);
};

var onClickUseGenomeBrowser = function onClickUseGenomeBrowser(_ref) {
  var heatmapData = _ref.heatmapData,
      _ref$heatmapConfig = _ref.heatmapConfig,
      experiment = _ref$heatmapConfig.experiment,
      atlasUrl = _ref$heatmapConfig.atlasUrl,
      outProxy = _ref$heatmapConfig.outProxy;
  return experiment ? function (x, y, genomeBrowser) {
    window.open(outProxy + (0, _urijs["default"])(experiment.urls.genome_browsers, atlasUrl).addSearch({
      experimentAccession: experiment.accession,
      name: genomeBrowser,
      geneId: heatmapData.yAxisCategories[y].info.trackId,
      trackId: heatmapData.xAxisCategories[x].info.trackId
    }).toString(), "_blank");
  } : undefined;
};

var makeEventCallbacks = function makeEventCallbacks(_ref2) {
  var heatmapData = _ref2.heatmapData,
      onSelectOntologyIds = _ref2.onSelectOntologyIds,
      heatmapConfig = _ref2.heatmapConfig;
  return {
    onHoverRowLabel: function onHoverRowLabel(yAxisLabel) {
      var rowIndex = heatmapData.yAxisCategories.findIndex(function (cat) {
        return cat.label === (0, _sanitizeHtml["default"])(yAxisLabel, noTags);
      });
      onSelectOntologyIds(_ontologyIdsForRowIndex(heatmapData, rowIndex));
    },
    onHoverColumnLabel: function onHoverColumnLabel(xAxisLabel) {
      var columnIndex = heatmapData.xAxisCategories.findIndex(function (cat) {
        return cat.label === xAxisLabel;
      });
      onSelectOntologyIds(_ontologyIdsForColumnIndex(heatmapData, columnIndex));
    },
    onHoverPoint: function onHoverPoint(x) {
      onSelectOntologyIds(_ontologyIdsForColumnIndex(heatmapData, x));
    },
    onHoverOff: function onHoverOff() {
      onSelectOntologyIds([]);
    },
    onClick: onClickUseGenomeBrowser({
      heatmapData: heatmapData,
      heatmapConfig: heatmapConfig
    })
  };
};

var _default = makeEventCallbacks;
exports["default"] = _default;